var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7516 20.8604V22.8904C14.7516 24.6104 13.1516 26.0004 11.1816 26.0004C9.21158 26.0004 7.60156 24.6104 7.60156 22.8904V20.8604C7.60156 22.5804 9.20158 23.8004 11.1816 23.8004C13.1516 23.8004 14.7516 22.5704 14.7516 20.8604Z",
    stroke: "#D3607D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7501 18.1097C14.7501 18.6097 14.6101 19.0697 14.3701 19.4697C13.7801 20.4397 12.57 21.0497 11.17 21.0497C9.77004 21.0497 8.56003 20.4297 7.97003 19.4697C7.73003 19.0697 7.59009 18.6097 7.59009 18.1097C7.59009 17.2497 7.99007 16.4797 8.63007 15.9197C9.28007 15.3497 10.17 15.0098 11.16 15.0098C12.15 15.0098 13.0401 15.3597 13.6901 15.9197C14.3501 16.4697 14.7501 17.2497 14.7501 18.1097Z",
    stroke: "#D3607D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7516 18.11V20.86C14.7516 22.58 13.1516 23.8 11.1816 23.8C9.21158 23.8 7.60156 22.57 7.60156 20.86V18.11C7.60156 16.39 9.20158 15 11.1816 15C12.1716 15 13.0616 15.35 13.7116 15.91C14.3516 16.47 14.7516 17.25 14.7516 18.11Z",
    stroke: "#D3607D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14.9702V17.0302C26 17.5802 25.56 18.0302 25 18.0502H23.0399C21.9599 18.0502 20.97 17.2602 20.88 16.1802C20.82 15.5502 21.0599 14.9602 21.4799 14.5502C21.8499 14.1702 22.36 13.9502 22.92 13.9502H25C25.56 13.9702 26 14.4202 26 14.9702Z",
    stroke: "#D3607D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.5V12.5C6 9.78 7.64 7.88 10.19 7.56C10.45 7.52 10.72 7.5 11 7.5H20C20.26 7.5 20.51 7.50999 20.75 7.54999C23.33 7.84999 25 9.76 25 12.5V13.95H22.92C22.36 13.95 21.85 14.17 21.48 14.55C21.06 14.96 20.82 15.55 20.88 16.18C20.97 17.26 21.96 18.05 23.04 18.05H25V19.5C25 22.5 23 24.5 20 24.5H17.5",
    stroke: "#D3607D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.afbff068d552b2322090f94ff5fdc771.svg";
export { ForwardRef as ReactComponent };